import moment from 'moment';

/**
 * File Overview
 * Normalization helper object for the body data API
 */
export default {
  normalize(data) {
    let newData = [];

    for (let prop in data) {
      if (data.hasOwnProperty(prop)) {
        const type = prop.toString().replace('latest_', '').replace('_session', '');
        let newObj = Object.assign({}, data[prop]);

        newObj['empty'] = Object.keys(newObj).length === 0 ? true : false;
        newObj['type'] = type;

        if (newObj.type === 'bike' && !newObj.empty) {
          newObj = this.normalizeBikeData(newObj);
        }

        if (newObj.type === 'shoe' && !newObj.empty) {
          newObj = this.normalizeShoeData(newObj);
        }

        newData.push(newObj);
      }
    }

    return this.order(newData);
  },

  normalizeBikeData(data) {
    if (data.bike_size) {
      data.bike_size = data.bike_size.replace('cm', '');
    }
    if (!(/([\d]+)\/?([\d]+)?/.test(data.bike_size))) {
      data.mountain = true;
    }

    return data;
  },

  normalizeShoeData(data) {
    if (data.shoe_size) {
      data.shoe_size = Number(data.shoe_size);
    }

    return data;
  },

  order(data) {
    return data.sort(function(a,b) {
      if (a.empty) return 1;
      if (b.empty) return -1;

      return moment(a.updated_at).isBefore(b.updated_at) ? -1 : 1;
    });
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/body-data-normalizer.js